import React, {useEffect, useState} from "react";
import Banner from "./components/Banner";
import AboutUs from "./components/AboutUs";
import Features from "./components/Features";
import WhyThis from "./components/WhyThis";
import Blog from "./components/Blog";
import {fetchPageDetails} from "../../../store/CommonSlice";
import {useAppDispatch} from "../../../store/app";
import {Helmet, HelmetProvider} from "react-helmet-async";
// import PeopleTalk from "./components/PeopleTalk";

const Home: React.FC<any> = () => {
    const dispatch = useAppDispatch();
    const defaultState = {
        id: 0,
        page_title: "",
        content: "",
        meta_title: "",
        meta_description: "",
    };
    const [pageDetails, setPageDetails] = useState(defaultState);
    useEffect(() => {
        dispatch(fetchPageDetails({slug: "home"}))
            .then((data: any) => {
                setPageDetails(data?.data);
            })
            .catch((error: any) => {
                console.log(error);
            });
    }, []);

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta name="title" content={pageDetails?.meta_title} />
                    <meta name="description" content={pageDetails?.meta_description} />
                </Helmet>
            </HelmetProvider>
            <div className="mainWrapper">
                <div className="line_pattern_wrap line_3">
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>

                <Banner />
                <AboutUs />
                <Features />
                <WhyThis />
                {/* <PeopleTalk /> */}
                <Blog />
            </div>
        </>
    );
};

export default Home;
